<template>
  <el-dialog
    :visible="true"
    width="1050px"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :fullscreen="true"
  >
    <div slot="title"
      style="display: flex; align-items: center;">
      <span>{{ title }}</span>
      <el-tag
        v-if="stockTaking.status && (type === 'update' || type === 'view')"
        size="small"
        :type="getStatus().tag"
        style="margin-left: 5px; margin-right: 5px"
      >
        {{ getStatus().label }}
      </el-tag>
    </div>
    <div v-if="type === 'view' && stockTaking.receipt_number">
      <el-link @click="openReceipt"
        type="primary"
        style="margin-bottom: 30px; margin-top: -20px;">
        <i class="el-icon-printer el-icon--right"></i>
        {{ stockTaking.receipt_number }}
      </el-link>
    </div>
    <div v-loading="loading">
      <el-form
        ref="stockTakingForm"
        label-position="top"
        :model="stockTaking"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="storage"
              label="Raktár"
            >
              <el-select
                v-model="stockTaking.storage"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="stockTaking.status !== 'recorded' || type === 'view'"
                @change="onStorageChange"
              >
                <el-option
                  v-for="storage in storages"
                  :key="storage.id"
                  :value="storage"
                  :label="storage.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
            v-if="stockTaking.storage.type === 'own'">
            <el-form-item
              prop="own_company"
              label="Saját cég"
            >
              <el-select
                v-model="stockTaking.own_company"
                :disabled="stockTaking.status !== 'recorded' || type === 'view'"
                style="width: 100%;"
                value-key="id"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="ownCompany in ownCompanies"
                  :key="ownCompany.id"
                  :value="ownCompany"
                  :label="ownCompany.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
            v-if="stockTaking.storage.type === 'representative'">
            <el-form-item
              prop="storage_user"
              label="Területi kepviselő"
            >
              <el-select
                v-model="stockTaking.storage_user"
                style="width: 100%;"
                value-key="id"
                :disabled="stockTaking.status !== 'recorded' || !stockTaking.storage || type === 'view'"
              >
                <el-option
                  v-for="storage_user in users"
                  :key="storage_user.id"
                  :value="storage_user"
                  :label="storage_user.last_name +' '+ storage_user.first_name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col>
          <el-form-item
            label=""
            prop="is_stockist"
            style="margin-bottom: 20px;"
          >
            <el-checkbox
              v-model="stockTaking.is_stockist"
              :disabled="type === 'view' || stockTaking.status !== 'done'"
            >
              Beszerzési árak véglegesek
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-row v-if="type !== 'view'">
          <el-col>
            <div
              
              style="text-align: right"
            >
              <el-button
                v-if="stockTaking.status !== 'recorded' && stockTaking.receipt_file"
                @click="openReceipt"
              >
                Bizonylat nyomtatása
              </el-button>
              <el-button
                type="primary"
                :disabled="loading"
                :loading="buttonLoading"
                @click="store"
              >
                {{ buttonText }}
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div v-if="stockTaking.status !== 'done' && type !== 'view'" class="add-item">
            <el-button
              :disabled="loading || buttonLoading || typeof stockTaking.storage.id === 'undefined'"
              icon="el-icon-plus"
              size="mini"
              @click="onAddProductClick"
            >
              Termék hozzáadása
            </el-button>
          </div>
        </el-row>
        <el-table :data="stockTaking.stock_taking_items" :border="true" :stripe="true" style="width: 100%">
            <el-table-column prop="name" label="Termék" />
            <el-table-column prop="pack_type_name" label="Kiszerelés" width="200" />
            <el-table-column prop="supplier_name" label="Beszállító" width="250" />
            <el-table-column prop="expiration_date" label="Szavatossági idő" width="150" />
            <el-table-column prop="count" label="Mennyiség" width="100" />
            <el-table-column prop="comment" label="Megjegyzés" width="150" />
            <el-table-column prop="purchase_unit_price" label="Beszer. Ár/db" width="150" />
            <el-table-column
              v-if="type !== 'view' && !loading && !buttonLoading"
              fixed="right"
              label=""
              width="135"
              align="center">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="onEditClick(scope.$index)"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                />
                <el-button
                  v-if="stockTaking.status !== 'done'"
                  @click.native.prevent="onDeleteClick(scope.$index)"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                />
              </template>
            </el-table-column>
        </el-table>
      </el-form>
    </div>


    <stock-taking-item-dialog
      v-if="itemDialogVisible"
      :item-to-modify="itemToModify"
      :purchase-unit-price-editable="stockTaking.status === 'done' && !stockTaking.is_stockist"
      :item-details-editable="stockTaking.status !== 'done'"
      @save="onItemSave"
      @close="itemDialogVisible = false"
    />

  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import StockTakingItemDialog from './StockTakingItemDialog.vue';

  export default {
    components: {
      StockTakingItemDialog,
    },
    props: ['type', 'stockTakingId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        itemDialogVisible: false,
        datePickerKey: 0,
        products: null,
        itemToModify: null,
        itemToModifyIdx: null,
        users: [],
        stockTaking: {
          status: 'recorded',
          stock_taking_items: [],
          storage: {},
          storage_user: {},
          own_company: {},
          is_stockist: false
        },
        rules: {
          storage_user: [
            {
              required: true,
              message: 'Raktár vezető kiválasztása kötelező',
              trigger: 'change'
            }
          ],
          storage: [
            {
              required: true,
              message: 'Raktár kiválasztása kötelező',
              trigger: 'change'
            }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új leltár';
        } else if (this.type === 'update') {
          return 'Leltár módosítása';
        } else if (this.type === 'view') {
          return 'Leltár megtekintése';
        } else {
          return '';
        }
      },
      buttonText() {
        return 'Mentés'
      },
      ownCompanies() {
        return this.$store.getters['ownCompany/ownCompanies'];
      },
      storages() {
        return this.$store.getters['storage/storages'];
      },
    },
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('ownCompany/fetchAll', ''),
        this.$store.dispatch('storage/fetchAll', ''),
        this.users = this.$store.dispatch('user/fetchAll', ''),
      ]);
      this.users.then(values => this.users = values);
      if (this.stockTakingId) {
        this.stockTaking = await this.$store.dispatch('stockTaking/fetch', this.stockTakingId);
      }
      this.loading = false;
    },
    methods: {
      onStorageChange(storage) {
        this.stockTaking.stock_taking_items = []
        if (storage) {
          if (storage.type === 'own') {
            this.stockTaking.own_company = this.ownCompanies[0];
          } else {
            this.stockTaking.own_company = {};
          }
          this.stockTaking.storage_user = {};
          this.users = this.$store.getters['user/users'].filter(user => user.id === storage.user_id || user.id === storage.deputy_user_id);
        }
      },
      onPriceChange({ netPrice, grossPrice }) {
        this.stockTaking.net_price = netPrice;
        this.stockTaking.gross_price = grossPrice;
      },
      handleClose() {
        if(this.type === 'view') {
          return this.$router.replace('/processes/stock-takings/stock-takings');
        }
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/processes/stock-takings/stock-takings');
        })
        .catch(() => {
        });
      },

      async store() {
        this.$refs.stockTakingForm.validate(async valid => {
          if (valid) {
            if (!this.stockTaking.stock_taking_items.length) {
              return this.$messageWrapper.warning('Minimum 1 termék hozzáadása kötelező.');
            }
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('stockTaking/create', this.stockTaking);
              } else if (this.type === 'update') {
                await this.$store.dispatch('stockTaking/update', this.stockTaking);
              }
              this.$store.dispatch('stockTaking/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/processes/stock-takings/stock-takings');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
      openReceipt() {
        if (this.stockTaking.receipt_file && this.stockTaking.receipt_file.path) {
          window.open(this.stockTaking.receipt_file.path);
        }
      },
      getStatus() {
        switch (this.stockTaking.status) {
          case 'recorded':
            return {
              label: 'Rögzítve',
              tag: 'info',
            };
          case 'done':
            return {
              label: 'Teljesített',
              tag: 'success',
            };
        }
      },
      onDeleteClick (itemIndex) {
        this.stockTaking.stock_taking_items.splice(itemIndex, 1)
      },
      onEditClick (itemIndex) {
        this.itemToModify = {...this.stockTaking.stock_taking_items[itemIndex]}
        this.itemToModifyIdx = itemIndex
        this.itemDialogVisible = true
      },
      onItemSave (item) {
        if (this.itemToModify && this.itemToModifyIdx !== null) {
          this.$set(
            this.stockTaking.stock_taking_items,
            this.itemToModifyIdx,
            {...item}
          )
          this.itemToModify = null
          this.itemToModifyIdx = null
        } else {
          this.stockTaking.stock_taking_items.unshift(item)
        }
      },
      onAddProductClick () {
        this.itemToModify = null
        this.itemToModifyIdx = null
        this.itemDialogVisible = true 
      }
    },
  };
</script>

<style>
  .add-item {
      padding: 1em;
      text-align: center;
  }
</style>
